import { useQuery } from "@tanstack/react-query";
import { equipmentStoreConsumableApi } from "./axios";
import {
    ServiceResponseI,
    ProfileTaskI,
    TaskI,
    StoreConsumableI,
    EquipmentStoreConsumableI,
    EquipmentI,
    CatalogueI,
} from '../../interfaces';
import {
    ValidateCurrentToken,
    LogoutSystem,
} from '../../helpers';
import { AxiosError } from 'axios';



export const getAllStoreConsumablesByEquipmentReference = async (reference: string): Promise<ServiceResponseI<StoreConsumableI[]>> => {

    try {
        const validateToken = ValidateCurrentToken();
        if (!validateToken) throw new Error('TOKEN INVALIDO');

        const params = new URLSearchParams();

        params.append('reference', reference);

        const { data } = await equipmentStoreConsumableApi.get<ServiceResponseI<StoreConsumableI[]>>(
            `/all-store-consumable-by-equipment-reference`,
            {
                params,
                headers: { 'Authorization': validateToken }
            });
        return data;
    } catch (err) {
        const obj = (err as AxiosError).response;

        if (obj?.status === 401) {
            LogoutSystem();
        }

        if (obj?.status === 400) {
            LogoutSystem();
        }

        throw new Error((obj?.data as Error).message)
    }
}

export const getAllStoreConsumablesByEquipmentId = async (id: number): Promise<ServiceResponseI<StoreConsumableI[]>> => {

    try {
        // const validateToken = ValidateCurrentToken();
        // if (!validateToken) throw new Error('TOKEN INVALIDO');


        const { data } = await equipmentStoreConsumableApi.get<ServiceResponseI<StoreConsumableI[]>>(
            `/all-store-consumable-by-equipment-id/${id}`,
        );
        return data;
    } catch (err) {
        const obj = (err as AxiosError).response;

        if (obj?.status === 401) {
            LogoutSystem();
        }

        if (obj?.status === 400) {
            LogoutSystem();
        }

        throw new Error((obj?.data as Error).message)
    }
}


export const getAllEquipmentsByStoreConsumableId = async (id: number): Promise<ServiceResponseI<CatalogueI[]>> => {

    try {
        const validateToken = ValidateCurrentToken();
        if (!validateToken) throw new Error('TOKEN INVALIDO');


        const { data } = await equipmentStoreConsumableApi.get<ServiceResponseI<CatalogueI[]>>(
            `/all-equipments-by-store-consumable-id/${id}`,
            {
                headers: { 'Authorization': validateToken }
            });
        return data;
    } catch (err) {
        const obj = (err as AxiosError).response;

        if (obj?.status === 401) {
            LogoutSystem();
        }

        if (obj?.status === 400) {
            LogoutSystem();
        }

        throw new Error((obj?.data as Error).message)
    }
}

export const getAllEquipmentStoreConsumableByEquipmentId = async (equipmentId: number): Promise<ServiceResponseI<EquipmentStoreConsumableI[]>> => {

    try {
        const validateToken = ValidateCurrentToken();
        if (!validateToken) throw new Error('TOKEN INVALIDO');

        const { data } = await equipmentStoreConsumableApi.get<ServiceResponseI<EquipmentStoreConsumableI[]>>(
            `/all-by-equipment-id/${equipmentId}`,
            {
                headers: { 'Authorization': validateToken }
            });
        return data;
    } catch (err) {
        const obj = (err as AxiosError).response;

        if (obj?.status === 401) {
            LogoutSystem();
        }

        if (obj?.status === 400) {
            LogoutSystem();
        }

        throw new Error((obj?.data as Error).message)
    }
}

export const equipmentStoreConsumablePost = async<T>(getForms: T): Promise<ServiceResponseI<string>> => {
    try {
        const validateToken = ValidateCurrentToken();
        if (!validateToken) throw new Error('TOKEN INVALIDO');
        const { data } = await equipmentStoreConsumableApi.post<ServiceResponseI<string>>("", getForms, { headers: { 'Authorization': validateToken } });
        return data;
    } catch (err) {
        const obj = (err as AxiosError).response;
        if (obj?.status === 401) {

            LogoutSystem();
        }
        throw new Error((obj?.data as Error).message)
    }
}

export const equipmentStoreConsumablePostByReference = async<T>(reference: string, getForms: T): Promise<ServiceResponseI<string>> => {
    try {
        const validateToken = ValidateCurrentToken();
        if (!validateToken) throw new Error('TOKEN INVALIDO');

        const params = new URLSearchParams();

        params.append('reference', reference);

        const { data } = await equipmentStoreConsumableApi.post<ServiceResponseI<string>>("/by-reference", getForms, { params, headers: { 'Authorization': validateToken } });
        return data;
    } catch (err) {
        const obj = (err as AxiosError).response;
        if (obj?.status === 401) {

            LogoutSystem();
        }
        throw new Error((obj?.data as Error).message)
    }
}

export const equipmentStoreConsumablePut = async<T>(id: number, updateForms: T): Promise<string> => {
    try {
        const validateToken = ValidateCurrentToken();
        if (!validateToken) throw new Error('TOKEN INVALIDO');
        const { data } = await equipmentStoreConsumableApi.put(`/${id}`, updateForms, { headers: { 'Authorization': validateToken } });
        return data;
    } catch (err) {
        const obj = (err as AxiosError).response;
        if (obj?.status === 401) {

            LogoutSystem();
        }
        throw new Error((obj?.data as Error).message)
    }
}

export const equipmentStoreConsumablebyId = async (id: number): Promise<ServiceResponseI<ProfileTaskI[]>> => {
    try {
        const validateToken = ValidateCurrentToken();
        if (!validateToken) throw new Error('TOKEN INVALIDO');
        const { data } = await equipmentStoreConsumableApi.get<ServiceResponseI<ProfileTaskI[]>>(`/all-by-id/${id}`, { headers: { 'Authorization': validateToken } });
        return data;
    } catch (err) {
        const obj = (err as AxiosError).response;
        if (obj?.status === 401) {

            LogoutSystem();
        }
        throw new Error((obj?.data as Error).message)
    }
}
